import { graphql, Link, useStaticQuery } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { FaLinkedin } from "react-icons/fa";
import Accreditations from "./Accreditations";
import { FaHeart } from "react-icons/fa";
import { SafeHtmlParser } from "./SafeHtmlParser";

const Footer = () => {
  // GraphQL query to fetch footer data
  const data = useStaticQuery(graphql`
    query FooterQuery {
      wpComponent(slug: { eq: "footer" }) {
        footerFields {
          logos {
            image {
              altText
              sourceUrl
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    formats: [WEBP, AUTO]
                    quality: 100
                    transformOptions: { cropFocus: CENTER, fit: COVER }
                    layout: CONSTRAINED
                    placeholder: BLURRED
                  )
                }
              }
            }
            link
          }
          linksColumn1 {
            heading
            links {
              link {
                target
                title
                url
              }
            }
          }
          linksColumn2 {
            heading
            links {
              link {
                target
                title
                url
              }
            }
          }
          linksColumn3 {
            heading
            links {
              link {
                target
                title
                url
              }
            }
          }
          linksColumn4 {
            heading
            links {
              link {
                target
                title
                url
              }
            }
          }
          linksColumn5 {
            heading
            links {
              link {
                target
                title
                url
              }
            }
          }
          companyRegistrationNumber
          companyAddress
        }
      }
    }
  `);

  const { footerFields } = data.wpComponent;

  return (
    <div>
      <Accreditations logos={footerFields.logos} />
      <footer className="bg-jason  py-5 py-lg-7">
        <Container>
          {/* Top Row with Dynamic Columns */}
          <Row className="mb-4 mb-lg-5 gy-4">
            {/* Logo Section */}
            <Col xs={12} xl={2} className="mb-4 mb-lg-0 ">
              <Link to="/">
                <StaticImage
                  src="../images/Logo-Light.png"
                  alt="Premier Support Services Logo"
                  style={{ maxWidth: "150px" }}
                />
              </Link>
              {footerFields.companyRegistrationNumber && (
                <div className="mt-4">
                  <h6 className="text-white">Company registration number:</h6>
                  <p className="text-white">
                    {footerFields.companyRegistrationNumber}
                  </p>
                </div>
              )}

              {footerFields.companyAddress && (
                <div>
                  <h6 className="text-white">Registered office address:</h6>
                  <div className="text-white">
                    <SafeHtmlParser htmlContent={footerFields.companyAddress} />
                  </div>
                </div>
              )}
            </Col>

            {/* Dynamic Footer Links */}
            {[
              footerFields.linksColumn1,
              footerFields.linksColumn2,
              footerFields.linksColumn3,
              footerFields.linksColumn4,
              footerFields.linksColumn5,
            ].map((column, index) => (
              <Col xs={6} md={true} xl={2} key={index}>
                <h6 className="text-white mb-4">{column.heading}</h6>
                <ul className="list-unstyled">
                  {column.links.map((link, idx) => (
                    <li className="mb-3" key={idx}>
                      {link.link.target === "_blank" ? (
                        <a
                          href={link.link.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-light white-link-yellow  text-decoration-none"
                        >
                          {link.link.title}
                        </a>
                      ) : (
                        <Link
                          to={link.link.url}
                          className="text-light white-link-yellow  text-decoration-none"
                        >
                          {link.link.title}
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              </Col>
            ))}
          </Row>

          <hr style={{ opacity: 1, color: "#FEDE34" }} className="mb-4" />

          {/* Bottom Row */}
          <Row className="align-items-center">
            {/* Copyright Text */}
            <Col lg={6} className="text-center text-md-start mb-4 mb-lg-0">
              <a
                className="white-link text-decoration-none d-flex align-items-center justify-content-center justify-content-lg-start"
                href="https://www.mativus.com"
              >
                Website designed & built by
                <StaticImage
                  src="../images/mativus-logo.png"
                  style={{ width: "100px" }}
                  imgStyle={{ objectFit: "contain" }}
                  className="ms-2"
                />
              </a>
            </Col>
            <Col
              lg={6}
              className="text-center text-md-start mb-3 mb-md-0 d-flex  justify-content-center justify-content-lg-end align-items-center flex-column flex-md-row"
            >
              <p className="text-white me-3 mb-4 mb-md-0">
                © {new Date().getFullYear()} Premier Support Services Limited.
                All rights reserved.
              </p>
              <a
                href="https://www.linkedin.com/company/premier-support-services-group"
                target="_blank"
                className="white-link-yellow me-3"
              >
                <FaLinkedin size={24} />
              </a>
            </Col>

            {/* Social Links */}
            {/* <Col md={2} className="text-center text-md-end">
              <a href="https://facebook.com" className="white-link-yellow me-3">
								<FaFacebookSquare size={24} />
							</a>
							<a
								href="https://instagram.com"
								className="white-link-yellow me-3"
							>
								<FaInstagram size={24} />
							</a>
							<a
								href="https://instagram.com"
								className="white-link-yellow me-3"
							>
								<FaXTwitter size={24} />
							</a>
              <a
                href="https://www.linkedin.com/company/premier-support-services-group"
                target="_blank"
                className="white-link-yellow me-3"
              >
                <FaLinkedin size={24} />
              </a>
            	<a href="https://youtube.com" className="white-link-yellow">
								<FaYoutube size={24} />
							</a>
            </Col> */}
          </Row>
        </Container>
      </footer>
    </div>
  );
};

export default Footer;
